<template>
  <v-container fluid style="height: 100%;padding-bottom: 125px;">
    <v-row>
      <v-col lg="3" sm="4" cols="12" style="padding-bottom: 0; max-height: 60px;">
        <v-text-field
          solo
          :label="$t('search')"
          append-icon="mdi-magnify"
          v-model="search"
          :color="colorTheme"
        ></v-text-field>
      </v-col>
      <v-col lg="2" md="3" sm="4" cols="12" style="padding-bottom: 0;">
        <v-btn
          style="width: 100%; margin: 0;"
          :color="colorTheme"
          class="white--text"
          v-on:click="newReport()"
        >
          {{ $t("new").toUpperCase() }}
          <v-icon right dark>mdi-plus</v-icon>
        </v-btn>
      </v-col>
      <v-col lg="1" md="3" sm="4" cols="12" style="padding-bottom: 0;">
        <v-btn
          style="width: 100%; margin: 0;"
          :loading="loading3"
          :disabled="loading3"
          :color="colorTheme"
          v-show="Allreports.length > 0"
          class="white--text"
          @click.native="loader = 'loading3'"
          v-on:click="BlobsForDownload()"
        >{{ $t("download").toUpperCase() }}</v-btn>
      </v-col>
      <v-col lg="1" md="3" sm="4" cols="12" style="padding-bottom: 0;">
        <v-btn
          style="width: 100%; margin: 0;"
          v-show="Allreports.length > 0"
          :color="colorTheme"
          class="white--text"
          v-on:click="ConfirmReports()"
        >{{ $t("delete").toUpperCase() }}</v-btn>
      </v-col>
      <v-col lg="12" sm="12" md="12">
        <v-data-table
          :no-data-text="$t('noResults')"
          v-model="Allreports"
          :headers="headersReports"
          :items="Reports"
          :search="search"
          show-select
          sort-by="date"
          :sort-desc="true"
          item-key="num"
          :items-per-page="5"
          class="elevation-1"
          :loading="progress"
          :loading-text="$t('loadingTextForTable')"
          :footer-props="{
            'items-per-page-text': $t('rows'),
            'items-per-page-all-text': $t('all')
          }"
          :custom-sort="customSort"
        >
          <template v-slot:items="props">
            <td class="text-xs-left">{{ props.item.name }}</td>
            <td class="text-xs-left">{{ props.item.date }}</td>
            <td class="text-xs-left">{{ props.item.columns }}</td>
            <td class="text-xs-left">{{ props.item.vehicles }}</td>
            <td class="text-xs-left">{{ props.item.type }}</td>
            <td class="text-xs-left">{{ props.item.period }}</td>
            <td class="text-xs-left">{{ props.item.createdBy }}</td>
          </template>
          <template v-slot:item.action="{ item }">
            <v-btn
              text
              small
              v-if="item.urlBlob.length > 0"
              :color="colorTheme"
              @click="GetBlob(item)"
              :loading="item.loading4"
              :disabled="item.loading4"
            >{{ $t("download").toUpperCase() }}</v-btn>
            <v-btn text small disabled v-else>{{ $t("inprocess").toUpperCase() }}</v-btn>
            <v-btn
              text
              small
              :color="colorTheme"
              v-on:click="Confirm(item)"
            >{{ $t("delete").toUpperCase() }}</v-btn>
          </template>
          <v-alert
            slot="no-results"
            :value="true"
            color="error"
            icon="mdi-alert"
          >{{ $t("noResults") }} : "{{ search }}".</v-alert>
          <template
            v-slot:footer.page-text="items"
          >{{ items.pageStart }} - {{ items.pageStop }} {{$t("of").toLowerCase()}} {{ items.itemsLength }}</template>
        </v-data-table>
      </v-col>
      <v-dialog v-model="confirm" hide-overlay persistent width="315">
        <v-card>
          <v-card-title
            class="headline"
            style="font-size: 14px !important;"
          >{{ $t("deleteConfirm") }}</v-card-title>
          <v-divider></v-divider>
          <v-card-text style="padding-top: 11px;">{{ rep.name }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
              :color="colorTheme"
              @click="confirm = false"
              v-on:click="confirmation(false)"
            >{{ $t("cancel").toUpperCase() }}</v-btn>
            <v-btn
              text
              :color="colorTheme"
              @click="confirm = false"
              v-on:click="confirmation(true)"
            >{{ $t("accept").toUpperCase() }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="confirmReports" hide-overlay persistent width="421px">
        <v-card>
          <v-card-title class="headline" style="font-size: 14px !important;">
            {{
            $t("deleteAllReports")
            }}
          </v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              text
              :color="colorTheme"
              @click="confirmReports = false"
              v-on:click="confirmationReports(false)"
            >{{ $t("cancel").toUpperCase() }}</v-btn>
            <v-btn
              text
              :color="colorTheme"
              @click="confirmReports = false"
              v-on:click="confirmationReports(true)"
            >{{ $t("accept").toUpperCase() }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import i18n from "@/plugins/i18n";
import { mapState } from "vuex";
import moment from "moment";

export default {
  name: "reportsPage",
  components: {
    filterVehicles: () => import("@/components/filterVehicles")
  },
  data() {
    return {
      authenticated: false,
      windowSize: {
        x: 0,
        y: 0
      },
      loader: null,
      loading3: false,
      search: "",
      confirm: false,
      sheet: true,
      rep: {},
      confirmReports: false
    };
  },
  created() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.$store.dispatch("getListOfReports");
    this.$store.commit("setTitle", "ALERTRUCK");
    this.$store.commit("setPageHeader", [
      this.$t("titleRep"),
      "",
      "",
      "",
      true
    ]);
  },
  watch: {
    loader() {
      const l = this.loader;
      this[l] = !this[l];
      setTimeout(() => (this[l] = false), 3000);
      this.loader = null;
    }
  },
  computed: {
    ...mapState([
      "headersReports",
      "reportList",
      "Reports",
      "finish",
      "progress",
      "colorTheme"
    ]),
    Allreports: {
      get: function() {
        return this.$store.state.Allreports;
      },
      set: function(val) {
        this.$store.commit("Allreports", val);
      }
    }
  },
  mounted() {},
  methods: {
    customSort(items, index, isDesc) {
      var formate =
        i18n.locale == "en" ? "MM/DD/YYYY HH:mm" : "DD/MM/YYYY HH:mm";
      items.sort((a, b) => {
        if (index[0] == "date") {
          if (isDesc[0]) {
            return (
              new Date(moment(b[index], formate).format("MM/DD/YYYY HH:mm")) -
              new Date(moment(a[index], formate).format("MM/DD/YYYY HH:mm"))
            );
          } else {
            return (
              new Date(moment(a[index], formate).format("MM/DD/YYYY HH:mm")) -
              new Date(moment(b[index], formate).format("MM/DD/YYYY HH:mm"))
            );
          }
        } else if (index[0] == "period") {
          if (isDesc[0]) {
            return (
              new Date(
                moment(b[index].split("-")[0], formate).format(
                  "MM/DD/YYYY HH:mm"
                )
              ) -
              new Date(
                moment(a[index].split("-")[0], formate).format(
                  "MM/DD/YYYY HH:mm"
                )
              )
            );
          } else {
            return (
              new Date(
                moment(a[index].split("-")[0], formate).format(
                  "MM/DD/YYYY HH:mm"
                )
              ) -
              new Date(
                moment(b[index].split("-")[0], formate).format(
                  "MM/DD/YYYY HH:mm"
                )
              )
            );
          }
        } else {
          if (typeof a[index] !== "undefined") {
            if (!isDesc[0]) {
              return a[index] < b[index] ? -1 : 1;
            } else {
              return b[index] < a[index] ? -1 : 1;
            }
          }
        }
      });
      return items;
    },
    newReport() {
      var offline = JSON.parse(localStorage.getItem("offline"));
      if (!offline) {
        if (this.$store.state.permissions) {
          this.$router.push({ name: "stepper" });
        } else {
          this.$store.commit("snackbar", {
            snackbar: true,
            text: i18n.t("permissions")
          });
        }
      } else {
        this.$store.commit("snackbar", {
          snackbar: true,
          text: i18n.t("later")
        });
      }
    },
    BlobsForDownload: async function(event) {
      if (this.Allreports.length > 0) {
        var offline = JSON.parse(localStorage.getItem("offline"));
        if (!offline) {
          this.$store.dispatch("getBlobs", this.Allreports);
        } else {
          this.$store.commit("snackbar", {
            snackbar: true,
            text: i18n.t("later")
          });
        }
      } else {
        this.$store.commit("snackbar", {
          snackbar: true,
          text: i18n.t("noReport")
        });
      }
    },
    ConfirmReports: async function(event) {
      if (this.Allreports.length > 0) {
        var offline = JSON.parse(localStorage.getItem("offline"));
        if (!offline) {
          this.confirmReports = true;
        } else {
          this.$store.commit("snackbar", {
            snackbar: true,
            text: i18n.t("later")
          });
        }
      } else {
        this.$store.commit("snackbar", {
          snackbar: true,
          text: i18n.t("noReport")
        });
      }
    },
    confirmationReports: function(val) {
      if (val) {
        this.$store.dispatch("DeleteBlobs", this.Allreports);
      }
    },
    GetBlob: async function(item) {
      this.$store.commit("loading4", [item, true]);
      this.$store.dispatch("getBlobAzure", item);
      setTimeout(() => this.$store.commit("loading4", [item, false]), 1000);
    },
    DeleteBlob: async function(id) {
      this.$store.dispatch("DeleteReport", id);
    },
    toggleAll() {
      var array = this.$store.state.Reports;
      if (this.selected.length) this.selected = [];
      else this.selected = array.slice();
    },
    confirmation: function(val) {
      if (val) {
        this.$store.dispatch("DeleteReport", this.rep.Id);
      }
    },
    Confirm(report) {
      this.rep = report;
      this.confirm = true;
    }
  }
};
</script>
